
import apiFetch from '../apiFetch'
export default function (token, dossierId, isHistorical = false) {
  return apiFetch({ endPoint: `Integrations/ToyotaInvoices/SetContractByDossier?dossierId=${dossierId}&isHistorical=${isHistorical}`, method: 'POST', body: null, token: token })
}
